import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { TableActionsPanel } from "app/pages/sales-intelligence/common-components/table-actions-panel";

export const StyledContactsActionsPanel = styled(TableActionsPanel)`
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
`;

export const StyledInnerContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 4px;
`;
